import { render, staticRenderFns } from "./materialsTable.vue?vue&type=template&id=7405ccc5"
import script from "./materialsTable.vue?vue&type=script&lang=js"
export * from "./materialsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports